import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, Bars3Icon, XMarkIcon } from '@heroicons/react/20/solid';
import acaStackLogo from '../../assets/acaStackLogo.png';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' },
  ];

  return (
    <header className="bg-white shadow-sm fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex justify-between items-center">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <a href="/">
            <img
              src={acaStackLogo}
              alt="Advanced Controls & Automation Logo"
              className="h-14 w-auto"
            />
          </a>
        </motion.div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          {navLinks.map((link) => (
            <motion.a
              key={link.href}
              href={link.href}
              className="text-gray-600 hover:text-blue-600 transition duration-300 font-medium text-base"
              whileHover={{ scale: 1.05 }}
            >
              {link.label}
            </motion.a>
          ))}
          <motion.a
            href="/login"
            className="text-white font-medium py-2 px-4 border border-blue-600 rounded-lg bg-blue-600 shadow-sm hover:bg-blue-700 hover:shadow-lg flex items-center space-x-1 transition duration-300"
            whileTap={{ scale: 0.95 }}
            whileFocus={{ scale: 0.95 }}
            whileHover={{ scale: 1.05 }}
          >
            <span>Login</span>
            <ArrowRightIcon className="w-4 h-4" />
          </motion.a>
        </nav>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <motion.button
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
            className="p-2 text-gray-600 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded-md"
            whileTap={{ scale: 0.9 }}
          >
            {isMenuOpen ? (
              <XMarkIcon className="w-6 h-6" />
            ) : (
              <Bars3Icon className="w-6 h-6" />
            )}
          </motion.button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-white border-t border-gray-200"
          >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col space-y-4">
              {navLinks.map((link) => (
                <motion.a
                  key={link.href}
                  href={link.href}
                  className="text-gray-600 hover:text-blue-600 transition duration-300 font-medium text-lg py-2"
                  whileHover={{ x: 5 }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </motion.a>
              ))}
              <motion.a
                href="/login"
                className="text-white font-medium py-2 px-4 border border-blue-600 rounded-lg bg-blue-600 shadow-sm hover:bg-blue-700 hover:shadow-lg flex items-center space-x-2 w-fit transition duration-300"
                whileTap={{ scale: 0.95 }}
                whileFocus={{ scale: 0.95 }}
                whileHover={{ scale: 1.05 }}
                onClick={() => setIsMenuOpen(false)}
              >
                <span>Login</span>
                <ArrowRightIcon className="w-5 h-5" />
              </motion.a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}